import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Phone, MessageCircle, FileText, Plus, X } from "lucide-react";
import { useLang } from "../../i18n";
import { CONTACT } from "../../data/content";

export const FloatingCTA = () => {
  const { ui } = useLang();
  const [open, setOpen] = useState(false);

  const actions = [
    { icon: Phone, label: ui.common.callNow, href: `tel:${CONTACT.phoneHref}`, testid: "fab-call", color: "bg-brand text-ink" },
    { icon: MessageCircle, label: "WhatsApp", href: `https://wa.me/${CONTACT.whatsapp}`, testid: "fab-whatsapp", color: "bg-[#25D366] text-ink" },
    { icon: FileText, label: ui.common.requestQuote, to: "/contact", testid: "fab-quote", color: "bg-surface2 text-white border border-white/15" },
  ];

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3">
      <AnimatePresence>
        {open &&
          actions.map((a, i) => {
            const Icon = a.icon;
            const inner = (
              <>
                <span className="rounded-full bg-ink/80 px-3 py-1 text-sm font-medium text-white backdrop-blur">{a.label}</span>
                <span className={`flex h-12 w-12 items-center justify-center rounded-full shadow-lg ${a.color}`}>
                  <Icon className="h-5 w-5" />
                </span>
              </>
            );
            return (
              <motion.div
                key={a.testid}
                initial={{ opacity: 0, y: 16, scale: 0.8 }}
                animate={{ opacity: 1, y: 0, scale: 1 }}
                exit={{ opacity: 0, y: 16, scale: 0.8 }}
                transition={{ delay: i * 0.05 }}
                className="flex items-center gap-3"
              >
                {a.to ? (
                  <Link to={a.to} data-testid={a.testid} className="flex items-center gap-3">{inner}</Link>
                ) : (
                  <a href={a.href} target="_blank" rel="noreferrer" data-testid={a.testid} className="flex items-center gap-3">{inner}</a>
                )}
              </motion.div>
            );
          })}
      </AnimatePresence>

      <button
        onClick={() => setOpen((o) => !o)}
        data-testid="fab-toggle"
        aria-label="Quick contact"
        className="glow-ring flex h-14 w-14 items-center justify-center rounded-full bg-brand text-ink transition-transform duration-300 hover:scale-105"
      >
        <motion.span animate={{ rotate: open ? 135 : 0 }} transition={{ duration: 0.3 }}>
          {open ? <X className="h-6 w-6" /> : <Plus className="h-6 w-6" />}
        </motion.span>
      </button>
    </div>
  );
};
